
import { defineComponent, reactive, computed } from "vue";
import useValidate from "@vuelidate/core";
import { required, minLength, sameAs } from "@vuelidate/validators";
import image from "@/assets/images/user.png";
import onboarding from "@/assets/images/icon-onboarding.png";
import XarcadeAccountService from "@/services/XarcadeAccountService";
import ResponseData from "@/_models/ResponseData";
import User from "@/_models/User";
import store from '@/store/index';
import { Helper } from "@/utils/Helper";

export default defineComponent({
  setup() {
    const state = reactive({
      oldPassword: "",
      password: "",
      confirmPassword: "",
    });

    const rules = computed(() => {
      return {
        oldPassword: { required },
        password: { required, minLength: minLength(8) },
        confirmPassword: {
          required,
          minLength: minLength(8),
          sameAs: sameAs(state.password),
        },
      };
    });

    const v$ = useValidate(rules, state);

    return {
      state,
      v$,
    };
  },

  data: function () {
    return {
      image: image,
      onboarding: onboarding,
      url: this.$route.query.page,
      resetPasswordSent: false,
      user: {
        username: "",
        email: "",
      } as User,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      hasChanged: false,

      showPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,
      isDisplayForgetPasswordModal: false,
    };
  },
  methods: {
    forgotPassword() {
      XarcadeAccountService.forgotPassword(this.user.email)
        .then((response) => {
          this.resetPasswordSent = true;
          Helper.toastSuccessHandling(response.data['message']);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
      this.resetPasswordSent = false;
    },

    changePassword() {
      this.v$.$validate();
      if (!this.v$.$error && this.userData !== '' ) {
          XarcadeAccountService.updatePassword(this.userData.userId, this.jwtToken, this.state.oldPassword, this.state.password)
            .then((response: ResponseData) => {
              Helper.toastSuccessHandling(response.data['message']);
            }).catch((error) => {
              Helper.endpointErrorHandling(error);
            })
        } else {
          Helper.endpointErrorHandling('', 'Passwords do not match!');
        }
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleNewPassword() {
      this.showNewPassword = !this.showNewPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },

    populateUserDetails() {
      if (this.userData !== "") {
        this.user.username = this.userData.username;
        this.user.email = this.userData.email;
      }
    },
  },

  mounted() {
    this.populateUserDetails();
  },

  name: 'accountPasswordComponent',
  components: {},
  props: ["company"],
});
